module.exports = __webpack_public_path__ + "img/chinesecompany35.15f825f4.png";